<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        New Product Compounds
      </h2>
      <small><em>Declining Compounds will close the case and its associated mapped structures</em></small>
    </b-container>
    <hr>

    <b-tabs card fill v-model="tabIndex">
      <b-tab :title="'New Compounds ('+new_compounds.length+')'" active>
        <b-card-text >
          <b-row style="padding: 10px;">
          <b-table
            ref="table"
            striped
            hover
            responsive
            :items="myProvider"
            :fields="fields"
            :busy.sync="loading"
            :current-page="options.currentPage"
            :per-page="options.perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template v-slot:cell(approve)="data">
                <span v-if="data.item.case_found == false" class="text-danger"><i class="fa fa-exclamation-triangle"></i> No Matching Case Found</span>
                <span v-if="data.item.case_found == true && data.item.case_updated == false && saving_index != data.index">
                  <b-button variant="success" @click="approve_decline(data.item.id, 'approve', data.index)">Approve</b-button>
                </span>
                <span v-if="data.item.case_found == true && data.item.case_updated == true && data.item.closed == false" class="text-capitalize">
                  Approved
                </span>
                <span v-if="saving_index == data.index" style="font-style: italic; padding-left: 10px;"><i class="fa fa-spinner fa-spin"></i> Saving...</span>
            </template>
            <template v-slot:cell(decline)="data">
                <span v-if="data.item.case_found == false" class="text-danger"><i class="fa fa-exclamation-triangle"></i> No Matching Case Found</span>
                <span v-if="data.item.case_found == true && data.item.case_updated == false && saving_index != data.index">
                  <b-button variant="danger" @click="approve_decline(data.item.id, 'decline', data.index)">Decline</b-button>
                </span>
                <span v-if="data.item.case_found == true && data.item.case_updated == true && data.item.closed" class="text-capitalize">
                  Declined
                </span>
            </template>
          </b-table>

          <b-pagination
            v-model="options.currentPage"
            :total-rows="options.totalRows"
            :per-page="options.perPage"
            align="right"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-row>
        </b-card-text>
      </b-tab>
       <b-tab :title="'Confirmed Compounds('+confirmed_compounds.length+')'">
        <b-card-text >
          <b-row style="padding: 10px;">
          <b-table
            ref="table"
            striped
            hover
            responsive
            :items="confirmedProvider"
            :fields="fields"
            :busy.sync="loading"
            :current-page="options.confirmedcurrentPage"
            :per-page="options.confirmedperPage"
            :sort-by.sync="confirmedsortBy"
            :sort-desc.sync="confirmedsortDesc"
          >
            <template v-slot:cell(approve)="data">
                <span v-if="data.item.case_found == false" class="text-danger"><i class="fa fa-exclamation-triangle"></i> No Matching Case Found</span>
                <span v-if="data.item.case_found == true && data.item.case_updated == false && saving_index != data.index">
                  <b-button variant="success" @click="approve_decline(data.item.id, 'approve', data.index)">Approve</b-button>
                </span>
                <span v-if="data.item.case_found == true && data.item.case_updated == true && data.item.closed == false" class="text-capitalize">
                  Approved
                </span>
                <span v-if="saving_index == data.index" style="font-style: italic; padding-left: 10px;"><i class="fa fa-spinner fa-spin"></i> Saving...</span>
            </template>
            <template v-slot:cell(decline)="data">
                <span v-if="data.item.case_found == false" class="text-danger"><i class="fa fa-exclamation-triangle"></i> No Matching Case Found</span>
                <span v-if="data.item.case_found == true && data.item.case_updated == false && saving_index != data.index">
                  <b-button variant="danger" @click="approve_decline(data.item.id, 'decline', data.index)">Decline</b-button>
                </span>
                <span v-if="data.item.case_found == true && data.item.case_updated == true && data.item.closed" class="text-capitalize">
                  Declined
                </span>
            </template>
          </b-table>

          <b-pagination
            v-model="options.confirmedcurrentPage"
            :total-rows="options.confirmedtotalRows"
            :per-page="options.confirmedperPage"
            align="right"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-row>
        </b-card-text>
       </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import { mapActions, mapGetters } from "vuex";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from 'lodash';

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      options: {
        currentPage: 1,
        totalRows: 10,
        perPage: 20,
        confirmedcurrentPage: 1,
        confirmedtotalRows: 10,
        confirmedperPage: 20,
      },
      loading: false,
      search: "",
      fields: [],
      new_compounds: [],
      confirmed_compounds: [],
      sortBy: "id",
      sortDesc: false,
      confirmedsortBy: "id",
      confirmedsortDesc: false,
      title: "",
      totalItems: 0,
      confirmedtotalItems: 0,
      stacked: false,
      subject_enrollment: "Enrolled",
      selected: [],
      saved: [],
      core_or_buffer_options: [
        { text: 'Approve', value: 'approve' },
        { text: 'Decline', value: 'decline', button_variant: 'danger' }
      ],
      saving_index: -1
    };
  },
  computed: {},
  watch: {
    subject_enrollment: function() {
      this.$refs.table.refresh();
    },
    selected: function(){
      let row = this.data[this.saving_index];
      if(row == undefined){
        return;
      }
      HTTP.post("/kenya/compound/assign_core_or_buffer/"+row.case_id+"/", {
        status: this.selected[this.saving_index]
      }).then(response => {
          if(response.data.status == 200){
            this.saved[this.saving_index] = true;
            this.saving_index = -1;
          }
      }).catch(error => {
        HandleErrors.HandleErrors(error);
      });
    }
  },
  methods: {
    ...mapActions("new_compound_count", [
      "getNewCompoundCount",
      "setNewCompoundCount"
    ]),
    refreshSideNavCount(){
      this.getNewCompoundCount().then((response) => {
                this.setNewCompoundCount(response.data);
            });
    },
    approve_decline: function(id, status, index){
      if(status == 'decline'){
        if(!confirm("Declining this compound will permanently close this case AND all of its associated structures.  Are you sure you want to continue?")){
          return;
        }
      }
      this.saving_index = index;
      const fd = new FormData();
      fd.append('status', status);
      HTTP.post("/kenya/compound/approve_decline/"+id+"/", fd).then(response => {
          if(!response.data.hasOwnProperty('closed')){
            alert("There was an error in closing the case and/or its mapped structures.  Please try again later.");
          }
          else{
            this.data[index].case_updated = true;
            this.data[index].closed = response.data.closed;
            this.refreshSideNavCount();
          }
          this.saving_index = -1;
          
      }).catch(error => {
        HandleErrors.HandleErrors(error);
      });
    },
    save_core_or_buffer: function(index){
      this.saving_index = index;
    },
    myProvider(ctx) {
      const that = this;

      return HTTP.get("/kenya/compounds/get_new", {
        params: {
          page: ctx.currentPage,
          count: ctx.perPage,
          sortBy: that.sortBy,
          sortDesc: that.sortDesc ? "" : "yes",
          confirmed: false
        }
      })
        .then(response => {
          let fields = [];
          _.each(response.data.fields, function(field) {
            fields.push({
              key: field,
              sortable: true
            });
            that.selected.push(null);
            that.saved.push(false);
          });
          that.fields = fields;

          that.new_compounds = response.data.data;
          that.totalItems = response.data.total;
          // that.fields = response.data.fields;
          that.options.totalRows = parseInt(response.data.total);
          return that.new_compounds;
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
          return [];
        });
    },
    confirmedProvider(ctx) {
        const that = this;

        return HTTP.get("/kenya/compounds/get_new", {
          params: {
            page: ctx.confirmedcurrentPage,
            count: ctx.confirmedperPage,
            sortBy: that.confirmedsortBy,
            sortDesc: that.confirmedsortDesc ? "" : "yes",
            confirmed: true
          }
        })
          .then(response => {
            let fields = [];
            _.each(response.data.fields, function(field) {
              fields.push({
                key: field,
                sortable: true
              });
              that.selected.push(null);
              that.saved.push(false);
            });
            that.fields = fields;

            that.confirmed_compounds = response.data.data;
            that.confirmedtotalItems = response.data.total;
            // that.fields = response.data.fields;
            that.options.confirmedtotalRows = parseInt(response.data.total);
            return that.confirmed_compounds;
          })
          .catch(error => {
            HandleErrors.HandleErrors(error);
            return [];
          });
      }
  }
};
</script>

<style></style>
